import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import './ModalOptions.scss';

const ModalOptions = ({
    disabled,
    onClick,
    img,
    title,
    content,
    buttonText,
    timeAlertText,
    onShowDisableTimeAlert,
}) => {
    const getDisableClass = classString => {
        const disableClass = disabled || timeAlertText ? `${classString}--disabled` : '';
        return `${classString} ${disableClass}`;
    };

    const getExtraMarginTop = classString => {
        const extraMarginTop = timeAlertText ? `${classString}__light-alert-extra-margin` : '';
        return `${classString} ${extraMarginTop}`;
    };

    useEffect(() => {
        if (timeAlertText && onShowDisableTimeAlert) {
            onShowDisableTimeAlert();
        }
    }, [timeAlertText]);

    return (
        <div className={getExtraMarginTop('modal-identification')}>
            {timeAlertText && <div className="modal-identification__light-alert"> {timeAlertText} </div>}
            <div className={'modal-bo-container'}>
                <div className={'modal-bo-container__info-box'}>
                    <div className={'modal-bo-container__info-box__head'}>
                        <div className={getDisableClass('modal-bo-container__info-box__head__img')}>
                            <img alt="icon" src={img} />
                        </div>
                        <div className={getDisableClass('modal-bo-container__info-box__head__title')}>{title}</div>
                    </div>

                    <div className={getDisableClass('modal-bo-container__info-box__content')}>{content}</div>
                </div>
                <button className={getDisableClass('modal-bo-container__button')} onClick={onClick}>
                    {buttonText}
                </button>
            </div>
        </div>
    );
};

ModalOptions.propTypes = {
    disabled: PropTypes.bool,
    content: PropTypes.string,
    title: PropTypes.string,
    img: PropTypes.node,
    buttonText: PropTypes.string,
    timeAlertText: PropTypes.string,
    onClick: PropTypes.func,
};

ModalOptions.defaultProps = {
    disabled: false,
    content: undefined,
    title: undefined,
    img: undefined,
    buttonText: undefined,
    timeAlertText: undefined,
    onClick: undefined,
};

export default ModalOptions;
